
import { Component, OnInit, OnDestroy, ViewChild, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ModulesComponent } from '../../../service/modules/modules.component';
import { ServerService } from '../../../service/server/server.service';
import { MessageService } from '../../../service/message/message.service';
import { HttpEventType } from '@angular/common/http';

@Component({
  selector: 'app-brand-detaile',
  templateUrl: './brand-detaile.component.html',
  styleUrls: ['./brand-detaile.component.scss']
})
export class BrandDetaileComponent implements OnInit, OnDestroy {
  public user_info: any = JSON.parse(<any>localStorage.getItem('user_info'));
  public loading: boolean = false;
  public list_device: any = [];
  public list_select_items: any = [];
  public list_selected_device: any = [];
  public subscription: Subscription | any;
  public server!: string;
  public server_main!: string;
  public site!: string;
  public type_task!: number;
  public form1_group: FormGroup | any;
  public user_id: number | any;
  public id!: number;
  public i!: number;
  public code!: number;
  public title!: string;
  public creator!: number;
  public expire!: boolean;
  public access_service!: number;
  public level!: number;
  public logo!: any;
  public logo_bin: boolean = false;
  public logo_type!: any;
  public logo_info!: any;
  public logo_loading: boolean = false;
  constructor(
    public serverService: ServerService,
    public router: Router,
    public messageService: MessageService,
    public matSnackBar: MatSnackBar,
    @Inject(MAT_DIALOG_DATA) private dialog_data: any,
    public dialog: MatDialog,
    public matDialogRef: MatDialogRef<BrandDetaileComponent>) {
    this.server = this.serverService.get_server();
    this.server_main = this.serverService.get_server();
    this.site = this.serverService.get_site();
    this.logo = this.serverService.get_default_image();
    if (this.user_info) {
      this.user_id = this.user_info.user_id;
    }
    this.create_form1();
    if (dialog_data) {
      this.type_task = dialog_data.type_task;
      this.id = dialog_data.id;
      this.code = dialog_data.code;
      this.i = dialog_data.i;
      if (this.type_task == 1) {
        this.check_access(5, 1);
      }
      if (this.type_task == 2) {
        this.check_access(4, 1);
      }
      if (this.type_task == 3) {
        if (this.dialog_data) this.creator = this.dialog_data.creator;
        this.form1_group.patchValue({
          title: dialog_data.search_array.title,
          title2: dialog_data.search_array.title2,
          status_id: dialog_data.search_array.status_id,
          status_title: dialog_data.search_array.status_title,
          device: dialog_data.search_array.device,
          device_title: dialog_data.search_array.device_title,
        })
      }
    }
  }//end consructor
  ngOnInit() {

  }
  create_form1() {
    this.form1_group = new FormGroup({
      'title': new FormControl(null, [Validators.required]),
      'title2': new FormControl(null, [Validators.required]),
      'status_title': new FormControl(null),
      'status_id': new FormControl(null, [Validators.pattern('[0-9]{1,}')]),
      'device_title': new FormControl(null),
      'device': new FormControl(null, [Validators.pattern('[0-9]{1,}')])
    });
    if (this.type_task == 2 || this.type_task == 1) {
      this.form1_group.controls['title'].setValidators([Validators.required]);
      this.form1_group.controls['title2'].setValidators([Validators.required]);
      this.form1_group.controls['status_id'].setValidators([Validators.required]);
      this.form1_group.controls['device'].setValidators([Validators.required]);
    }
  }
  check_access(type_task: any, excel: number): any {
    if (this.messageService.check_internet() == false) {
      this.message(true, this.messageService.internet(), 1, this.messageService.close());
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.loading = true;
    var obj = {
      'address': 6,
      'type': 'user',
      'user_id': this.user_id,
      'id': this.code
    }
    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res: any): any => {
        if (res['status'] == 1) {
          this.creator = res['creator'];
          this.level = res['level'];
          this.access_service = res['result'][0].count;
          this.check_access2(type_task, excel, res['result'][0].count);
        }//end if
        else {
          this.message(true, this.messageService.access(), 1, this.messageService.close());
        }
      }
    )
  }
  check_access2(type_task: any, excel: number, access_service: number): any {
    var obj = {
      'address': 6,
      'user_id': this.creator,
      'id': this.code
    }
    this.subscription = this.serverService.post_address(this.server_main, 'new_address', obj).subscribe(
      (res: any): any => {
        if (res['status'] == 1) {
          if (res['result'][0].count == 0) {
            this.message(true, this.messageService.access2(), 1, this.messageService.close());
            return false;
          }
          else if (this.level == 3 && access_service == 0) {
            this.message(true, this.messageService.access2(), 1, this.messageService.close());
            return false;
          }
          this.title = res['result'][0].title;
          this.expire = res['expire'];
          this.loading = false;
          if (type_task == 1) {
            if (this.expire == true) {
              this.message(true, this.messageService.expire(), 1, this.messageService.close());
              return false;
            } else {
              this.insert();
            }
          }
          if (type_task == 2) { this.update(); }
          if (type_task == 3) { this.search(excel); }
          if (type_task == 4) { this.get_data(); }
          if (type_task == 5) {
            this.get_status();
            this.get_device();
          }
        }//end if
        else {
          this.message(true, this.messageService.access(), 1, this.messageService.close());
        }
      }
    )
  }
  search(excel: number) {
    this.matDialogRef.close({
      title: this.form1_group.value.title,
      title2: this.form1_group.value.title2,
      status_id: this.form1_group.value.status_id,
      status_title: this.form1_group.value.status_title,
      device: this.form1_group.value.device,
      device_title: this.form1_group.value.device_title,
      export_excel: excel
    })
  }
  get_data() {
    if (this.messageService.check_internet() == false) {
      this.message(true, this.messageService.internet(), 1, this.messageService.close());
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.loading = true;
    var obj = {
      'address': 6702,
      'id': this.id
    }
    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          this.form1_group.patchValue({
            'title': res['result'][0].repairman_brand_title,
            'title2': res['result'][0].repairman_brand_title2,
            'status_id': res['result'][0].repairman_brand_status,
            'status_title': res['result'][0].status_title,
            'device': res['result'][0].wharehouse_device_id,
            'device_title': res['result'][0].wharehouse_device_title,
          })
          this.logo_info = {
            site: res['result'][0].repairman_brand_site_logo,
            path: res['result'][0].repairman_brand_logo
          }
          if (res['result'][0].repairman_brand_logo) {
            this.logo = res['result'][0].repairman_brand_site_logo + "/" + res['result'][0].repairman_brand_logo;
            this.logo_bin = true;
            this.logo_type = res['result'][0].repairman_brand_logo.split(".").pop();
          }
          else {
            this.logo = this.serverService.get_default_image();
            this.logo_bin = false;
          }
          this.list_selected_device = res['result'][0].repairman_brand_device;
          this.list_select_items = res['result'][0].repairman_brand_device;
          this.get_device();
        }//end if
        else {
          this.message(true, this.messageService.erorr_in_load(), 1, this.messageService.close());
        }
      }
    )
  }
  insert() {
    if (this.messageService.check_internet() == false) {
      this.message(true, this.messageService.internet(), 1, this.messageService.close());
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.loading = true;
    var obj = {
      'address': 1666,
      "user_id": this.user_id,
      'status_id': this.form1_group.value.status_id,
      'device': this.list_select_items,
      'title': this.form1_group.value.title,
      'title2': this.form1_group.value.title2,
      'creator': this.creator,
      'logo_info': this.logo_info
    }
    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          this.matDialogRef.close(
            { result: res['result'][0] }
          )
          this.message(true, this.messageService.save(), 1, this.messageService.close());
        }//end if
        else if (res['status'] == 4) {
          this.message(true, this.messageService.repeat(), 1, this.messageService.close());
        }
        else {
          this.message(true, this.messageService.erorr_in_save(), 1, this.messageService.close());
        }
      }
    );
  }//end insert
  update() {
    if (this.messageService.check_internet() == false) {
      this.message(true, this.messageService.internet(), 1, this.messageService.close());
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.loading = true;
    var obj = {
      'address': 1667,
      "user_id": this.user_id,
      'title': this.form1_group.value.title,
      'title2': this.form1_group.value.title2,
      'device': this.list_select_items,
      'status_id': this.form1_group.value.status_id,
      'creator': this.creator,
      'id': this.id,
      'logo_info': this.logo_info
    }
    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          this.matDialogRef.close(
            { result: res['result'][0], i: this.i }
          )
          this.message(true, this.messageService.save(), 1, this.messageService.close());
        }//end if
        else if (res['status'] == 4) {
          this.message(true, this.messageService.repeat2(), 1, this.messageService.close());
        }
        else {
          this.message(true, this.messageService.erorr_in_save(), 1, this.messageService.close());
        }
      }
    );
  }//end update
  get_status() {
    if (this.messageService.check_internet() == false) {
      this.message(true, this.messageService.internet(), 1, this.messageService.close());
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', { address: 1 }).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          this.form1_group.patchValue({
            status_id: res['result'][0].status_id,
            status_title: res['result'][0].status_title,
          })
          this.message(false, "", 1, this.messageService.close());
        }//end if
        else {
          this.message(true, this.messageService.erorr_in_load(), 1, this.messageService.close());
        }
      }
    )
  }
  get_device() {
    var selected_array: any = [];
    if (this.list_selected_device && this.type_task == 2) {
      selected_array = this.list_selected_device.split(",").map((items) => {
        return parseInt(items);
      });
    }
    var obj = {
      'address': 6732,
      'creator': this.creator
    }
    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res: any) => {
        this.list_device = [];
        if (res['status'] == 1) {
          for (var i = 0; i < res['num']; i++) {
            if (selected_array.indexOf(res['result'][i].wharehouse_device_id) != -1) {
              res['result'][i].checked = true;
            }
            this.list_device.push(res['result'][i]);
          }//end for
          this.message(false, "", 1, this.messageService.close());
        }//end if
        else {
          this.message(true, this.messageService.erorr_in_load(), 1, this.messageService.close());
        }
      }
    )
  }
  select_items() {
    this.list_select_items = [];
    var list_select_items_temp = <any>document.getElementsByName("device[]");
    for (var i = 0; i < list_select_items_temp.length; i++) {
      if (list_select_items_temp[i].checked == true) {
        this.list_select_items.push(list_select_items_temp[i].value);
      }
      this.list_select_items = this.list_select_items.map(function (items) {
        return parseInt(items);
      })
    }
  }
  //**************************************************************************************************************** */
  change_logo(event: any): any {
    var selectedFile = <File>event.target.files[0];
    if (selectedFile.type.split("/").shift() != 'image') {
      var message = "فرمت ارسالی برای این فیلد فقط می بایست عکس  باشد.";
      this.message(true, this.messageService.message(message), 1, this.messageService.close());
      return false;
    }
    else {
      this.logo_loading = true;
      var fd = new FormData();
      fd.append("image", selectedFile, selectedFile.name);
      this.serverService.post_address_file(this.server, "uploadImageBrands", fd).subscribe(
        (event: any) => {
          if (event.type === HttpEventType.UploadProgress) {
            ///this.uploadedAvaterProgess = (event.loaded / event.total) * 100;
          }
          else if (event.type === HttpEventType.Response) {
            var a = <any>event.body;
            this.logo = this.serverService.get_site_upload_image() + "/object/uploads/images-brand/" + a.result.filename;
            this.logo_bin = true;
            this.logo_type = selectedFile.type.split("/").pop();
            this.logo_loading = false;
            this.logo_info = {
              'site': this.serverService.get_site_upload_image(),
              'path': "object/uploads/images-brand/" + a.result.filename
            }
          }
        }
      )
    }
  }
  delete_logo() {
    this.logo = this.serverService.get_default_image();
    this.logo_bin = false;
    this.logo_info = {
      path: '',
      site: ''
    }
    this.logo_type = '';
  }
  open_logo(): any {
    if (this.logo == '../../../../assets/images/default_image.png') {
      return false;
    } else {
      window.open(this.logo, "_blank");
    }
  }
  //*********************************************************************************************************** */
  load_services(id: number) {
    const dialogRef = this.dialog.open(ModulesComponent, {
      width: '40rem',
      height: 'auto',
      disableClose: true,
      data: { id: id, creator: this.creator }
    });
    dialogRef.afterClosed().subscribe(
      (res: any) => {
        if (res) {
          if (id == 26) {
            this.form1_group.patchValue({
              'status_id': res.id,
              'status_title': res.title
            })
          }
          if (id == 154) {
            this.form1_group.patchValue({
              'device': res.id,
              'device_title': res.title
            })
          }
        }
      }
    )
  }
  reset_input(id: number) {
    if (id == 26) {
      this.form1_group.patchValue({
        'status_title': null,
        'status_id': null
      })
    }
    if (id == 154) {
      this.form1_group.patchValue({
        'device': null,
        'device_title': null
      })
    }
  }
  close() {
    this.matDialogRef.close();
  }
  //**************************************************
  required() {
    if (this.type_task == 1 || this.type_task == 2) {
      return true;
    }
    else {
      return false;
    }
  }
  //**************************************************
  message(validation: boolean, message: string, type: number, action: string) {
    if (type == 1) this.loading = false;
    if (validation == true) {
      this.matSnackBar.open(message, action, { duration: 4000 });
    }//end if
    else {
      //this.matSnackBar.dismiss();
    }
  }//end 
  //*******************************************************************************
  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }//end if
  }//end OnDestroy
}
